import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { CITIES } from "../lib/gj";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const requestedRole = params.get("role");

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "customer",
    phone: "",
    business_name: "",
    city: "Kolkata",
  });
  const [loading, setLoading] = useState(false);

  // Dealers must use the legal onboarding flow.
  if (requestedRole === "dealer") {
    return <Navigate to="/dealer-onboarding" replace />;
  }

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register({
      ...form,
      email: form.email.trim().toLowerCase(),
    });
    setLoading(false);
    if (res.ok) {
      toast.success("Account created. Welcome!");
      nav(res.user.role === "dealer" ? "/dealer" : "/", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2" data-testid="register-page">
      <div className="flex items-center justify-center px-4 py-16 order-2 lg:order-1">
        <form onSubmit={onSubmit} className="w-full max-w-md" data-testid="register-form">
          <div className="gj-divider-gold mb-4" />
          <h1 className="font-heading text-3xl font-extrabold text-[#0A192F]">Create your account</h1>
          <p className="text-sm text-[#4A5568] mt-1">
            Sign up to save favourites, send enquiries and track cars you love.
          </p>
          <p className="text-xs text-[#718096] mt-3 bg-[#F3F0EA]/60 border border-[#0A192F]/5 rounded-md px-3 py-2">
            Selling cars or running a showroom?{" "}
            <Link to="/dealer-onboarding" className="text-[#0A192F] font-semibold underline hover:text-[#F97316]">
              Register as a dealer →
            </Link>
          </p>

          <div className="mt-6 space-y-4">
            <div>
              <Label htmlFor="r-name">Full name</Label>
              <Input id="r-name" value={form.name} onChange={(e) => update("name", e.target.value)} required data-testid="register-name" />
            </div>
            <div>
              <Label htmlFor="r-email">Email</Label>
              <Input id="r-email" type="email" value={form.email} onChange={(e) => update("email", e.target.value)} required data-testid="register-email" />
            </div>
            <div>
              <Label htmlFor="r-pw">Password</Label>
              <Input id="r-pw" type="password" value={form.password} onChange={(e) => update("password", e.target.value)} required minLength={6} data-testid="register-password" />
            </div>
            <div>
              <Label htmlFor="r-phone">Phone (WhatsApp)</Label>
              <Input id="r-phone" value={form.phone} onChange={(e) => update("phone", e.target.value)} placeholder="98XXXXXXXX" data-testid="register-phone" />
            </div>

            {form.role === "dealer" && (
              <></>
            )}

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#0A192F] hover:bg-[#112240] text-white py-6"
              data-testid="register-submit-btn"
            >
              {loading ? "Creating…" : "Create account"}
            </Button>
          </div>

          <div className="mt-6 text-sm text-[#4A5568] text-center">
            Already a member?{" "}
            <Link to="/login" className="text-[#0A192F] font-semibold hover:text-[#F97316]">
              Sign in
            </Link>
          </div>
        </form>
      </div>

      <div className="hidden lg:block bg-[#0A192F] relative overflow-hidden order-1 lg:order-2">
        <img
          src="https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=1400"
          alt="Showroom"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 gj-hero-gradient" />
        <div className="relative h-full p-16 flex flex-col justify-end text-white">
          <div className="gj-divider-gold mb-4" />
          <div className="font-heading text-4xl font-extrabold leading-tight">
            Join Bengal's most <br />
            <span className="text-[#F97316]">trusted car marketplace.</span>
          </div>
          <p className="mt-3 text-white/70 max-w-md">
            500+ cars listed, 120+ verified dealers. Your next deal starts here.
          </p>
        </div>
      </div>
    </div>
  );
}
